import { washArabic } from '@/utils/wash.js'
export const washData = (node) => {
  washArabic(node)
}
